export default __webpack_public_path__ + "media/components/InstructionButton/images/rule4-23c47b2d79e3bfd1cce997793e716654.png";